import React from "react";
import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import CustomCsvToolbar from "../components/CustomCsvToolbar/CustomCsvToolbar";
import CustomCsvRawData from "../controllers/custom_csv_raw_data/CustomCsvRawData";
import CustomCsvRawDataNewNavigation from "../controllers/custom_csv_raw_data/CustomCsvRawDataNewNavigation";
import { getConfigVariable } from "../config/config";
import { controllerQueries } from "../controllers/utils/utils";
import { hasModule } from "../utils/utils";

const queries = (args = {}) => {
    const resource = "custom_csv_raw_data";
    const queryArgs = {
        entity: args.entityRawData || "",
        projectId: args.projectId,
        fiscalYear: args.fiscalYear,
        importId: args.importId,
        filter: args.filter
            ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
            : undefined,
        sort: args.sort ? { type: "[SortInput!]", value: parseFilter(args.sort) } : undefined,
        page: parseInt(args.page, 10) || 0,
        pageSize: parseInt(args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE")),
    };

    const queryBody = `__typename, items, headerItems, metadata, filters(entity:$entity){ prop, name, type, list, disableOperators, mandatory}`;

    return [
        {
            resource,
            args: { ...queryArgs },
            body: `${queryBody}, rawDataEdit`,
            downloadable: false,
            isDatagridReq: true,
        },
        {
            resource: `${resource}_export`,
            args: { ...queryArgs },
            body: queryBody,
            downloadable: true,
            downloadOnly: true,
            downloadFilePrefixName: resource,
        },
    ];
};

/**
 * CustomCsvRawDataComponent is a wrapper that switches between CustomCsvRawDataNewNavigation (new navigation)
 * and CustomCsvRawData (old navigation) based on whether new_navigation module is enabled.
 * Same pattern as RawDataComponent in rawData.js.
 */
const CustomCsvRawDataComponent = (props) => {
    const { modules } = props;
    return hasModule(modules, "new_navigation") ? <CustomCsvRawDataNewNavigation {...props} /> : <CustomCsvRawData {...props} />;
};

/**
 * Attach queries from both controllers so DataLoader can execute them
 */
CustomCsvRawDataComponent.queries = (args, userModulesByProject) => {
    return controllerQueries(args, userModulesByProject);
};

const customCsvRawData = (path, navigation, exact, navByImportId = false) => ({
    path,
    navigation,
    component: CustomCsvRawDataComponent,
    queries,
    exact,
    navByImportId,
    title: "label(param(entity))",
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).items",
                rawDataEdit: "query(0).rawDataEdit",
                header: "query(0).headerItems",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                total: "query(0).metadata.total",
                onRowEdit: true,
                cellHighlight: true,
                hideDeleteSeriesButton: true,
                basePath: path,
                toolbar: CustomCsvToolbar,
                toolbarProps: {
                    data: "query(0).items",
                },
                onRowClickCustom: () => { },
            },
        },
    ],
});

export default customCsvRawData;


